import clsx from 'clsx'

import { ResourceListCardSkeleton } from './ResourceListCardSkeleton'
import { Skeleton } from './Skeleton'

export type PageCarouselSkeletonProps = {
  className?: string
  slides?: number
  thumbClassName?: string
}

/**
 * Carrossel horizontal de cards em destaque (ex.: top likes em parceiros).
 */
export const PageCarouselSkeleton = ({
  className,
  slides = 2,
  thumbClassName
}: PageCarouselSkeletonProps) => (
  <div
    className={clsx('flex w-full flex-col gap-4', className)}
    aria-hidden
  >
    {Array.from({ length: slides }).map((_, index) => (
      <ResourceListCardSkeleton
        key={index}
        highlight
        withFeaturedStrip
        thumbClassName={thumbClassName}
        railClassName="w-[70px]"
      />
    ))}
  </div>
)

export type PageListScreenSkeletonProps = {
  className?: string
  /** Carrossel horizontal acima da lista. */
  showCarousel?: boolean
  carouselSlides?: number
  /** Quantidade de cards na lista principal. */
  itemCount?: number
  itemClassName?: string
  thumbClassName?: string
  'aria-label'?: string
}

/**
 * Conteúdo scrollável de uma tela de listagem — composição canônica para
 * `Screen.Content` enquanto `isLoading` na carga inicial.
 */
export const PageListScreenSkeleton = ({
  className,
  showCarousel = false,
  carouselSlides = 2,
  itemCount = 5,
  itemClassName,
  thumbClassName,
  'aria-label': ariaLabel = 'Carregando conteúdo'
}: PageListScreenSkeletonProps) => (
  <div
    className={clsx('flex flex-col gap-4 pb-2', className)}
    aria-busy="true"
    aria-label={ariaLabel}
  >
    {showCarousel && (
      <PageCarouselSkeleton slides={carouselSlides} thumbClassName={thumbClassName} />
    )}

    <div className="flex flex-col gap-4">
      {Array.from({ length: itemCount }).map((_, index) => (
        <ResourceListCardSkeleton
          key={index}
          className={itemClassName}
          thumbClassName={thumbClassName}
        />
      ))}
    </div>
  </div>
)
